import Http from 'vue-resource/src/http'
import Turbolinks from 'turbolinks'
import {app} from '../../../common/app'

const state = {
  clientDiligence: false,
  diligences: null,
  url: null
}

const getters = {
  clientDiligence: state => state.clientDiligence,
  diligences: state => state.diligences
}

const mutations = {
  initClientDiligence: (state, url) => {
    state.url = url
    state.clientDiligence = false

    return new Promise((resolve, reject) => {
      const structure = Http.get(state.url)
      Promise.all([structure]).then((response) => {
        state.clientDiligence = response[0].data
        state.diligences = state.clientDiligence.diligences
        resolve(this) // eslint-disable-line no-invalid-this
      }).catch((response) => {
        reject(response)
      })
    })
  }
}

const actions = {
  processClientDiligence({state, dispatch}, {data, setBack}) {
    setBack = setBack || false
    const confirmed = state.clientDiligence.confirmed
    const completed = state.clientDiligence.completed

    Http.patch(state.url, data).then(response => {
      const diligence = response.body
      if (confirmed != diligence.confirmed || completed != diligence.completed) {
        app.notify('Client Diligence was changed. Updating...', {type: 'info'})
        Turbolinks.clearCache()
        Turbolinks.reload()
      } else if (setBack) {
        state.clientDiligence = response.body
        state.diligences = response.body.diligences
      } else {
        state.clientDiligence.confirm = response.body.confirm
      }
    }, response => {
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
